import { IProductGroup } from '@alberta/konexi-shared';
import { Inject, Injectable, NgZone } from '@angular/core';
import { ProductGroupChannel } from 'src/app/business/product-group/contracts/product-group-channel';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { ProductGroupModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { SyncService } from './sync.service';
import { TrackerService } from '@services/tracker.service';

@Injectable()
export class ProductGroupSyncService extends SyncService<IProductGroup> {
  constructor(
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<IProductGroup>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync
  ) {
    super(ProductGroupModelName, appController, dispatcher, eventService, ngZone, platformSync);
  }

  public canSync(channel: string): boolean {
    return (
      channel === ProductGroupChannel.CREATE ||
      channel === ProductGroupChannel.EDIT ||
      channel === ProductGroupChannel.DELETE
    );
  }
}
